export const da = {
    LEFT: 'Venstre: gå til den forrige dag.',
    RIGHT: 'Til højre: Flyt til næste dag.',
    DOWN: 'Ned: Flytter til næste række.',
    UP: 'Up: gå til den forrige række.',
    PGUP: 'PgUp: gå til den forrige måned.',
    PGDOWN: 'PgDown: Flytter til den næste måned.',
    HOME: 'Hjem: gå til forrige år.',
    END: 'Slut: gå til det næste år.',
    ESC: 'Esc/i Dag/Luk: lukker kalender.',
    TITLE: 'Tastatur Instruktioner'
};
